export default {
  state: {
    companies: [
      {
        label: 'Reach World',
        value: 'reachWorld',
        src: 'https://reachworld.com/signature/rw-logo.png',
        width: 169,
        style: '',
        href: 'https://reachworld.com/?utm_source=Mail&utm_medium=Email-Signature',
        banner: {
          href: 'https://reachworld.com/?utm_source=Mail&utm_medium=Email-Signature',
          src: 'https://reachworld.com/signature/logos-banner.png'
        }
      },
      {
        label: 'RRE & RI',
        value: 'reachRRE&RI',
        src: 'https://reachworld.com/signature/rre-ri-logo.png',
        width: 242,
        style: 'padding:28.465px 0;',
        href: 'https://reachworld.com/?utm_source=Mail&utm_medium=Email-Signature',
        banner: {
          href: 'https://reachworld.com/?utm_source=Mail&utm_medium=Email-Signature',
          src: 'https://reachworld.com/signature/logos-banner.png'
        }
      },
      {
        label: 'RRE',
        value: 'reachRealEstate',
        src: 'https://reachworld.com/signature/rre-logo.png',
        width: 169,
        style: '',
        href: 'https://reachrealestate.com/?utm_source=Mail&utm_medium=Email-Signature',
        banner: {
          href: 'https://reachrealestate.com/?utm_source=Mail&utm_medium=Email-Signature',
          src: 'https://reachworld.com/signature/logos-banner.png'
        }
      },
      {
        label: 'Reach Publishers',
        value: 'reachPublishers',
        src: 'https://reachworld.com/signature/rp-logo.png',
        width: 169,
        style: '',
        href: 'https://reachpublishers.com/?utm_source=Mail&utm_medium=Email-Signature',
        banner: {
          href: 'https://reachpublishers.com/?utm_source=Mail&utm_medium=Email-Signature',
          src: 'https://reachworld.com/signature/logos-banner.png'
        }
      },
      {
        label: 'Reach Study Abroad',
        value: 'reachStudyAbroad',
        src: 'https://reachworld.com/signature/rsa-logo.png',
        width: 169,
        style: '',
        href: 'https://reach-studyabroad.com/?utm_source=Mail&utm_medium=Email-Signature',
        banner: {
          href: 'https://reach-studyabroad.com/?utm_source=Mail&utm_medium=Email-Signature',
          src: 'https://reachworld.com/signature/logos-banner.png'
        }
      },
      {
        label: 'Kaleela',
        value: 'kaleela',
        src: 'https://kaleela.com/wp-content/uploads/2025/02/logo.png',
        width: 169,
        style: '',
        href: 'https://kaleela.com/?utm_source=Mail&utm_medium=Email-Signature',
        banner: {
          href: 'https://kaleela.com/?utm_source=Mail&utm_medium=Email-Signature',
          src: 'https://reachworld.com/signature/logos-banner.png'
        }
      }
    ],
    selected: 'reachWorld'
  },
  getters: {
    getCompany: state => state
  },
  mutations: {
    SET_COMPANY_SELECTED (state, data) {
      state.selected = data
    }
  },
  actions: {
    async updateCompany ({ commit, dispatch, rootState }, payload) {
      commit('SET_COMPANY_SELECTED', payload)
    }
  }
}
